/*
 * Encapsulates reading values from the query string.
 */
export default class Query {
    public static get(key: string, parent = false) : string {
        return this.all(parent)[key];
    }

    public static all(parent = false) : any {
        let search;
        if (parent) {
            try {
                search = window.parent.location.search;
            } catch {
                // If the parent location is not accessible due to
                // domain restriction, return an empty dictionary
                return {};
            }
        } else {
            search = window.location.search;
        }

        if (!search)
            return {};

        const dict = {},
            parts = search.substring(1).split('&');
        
        parts.forEach((part: string) => {
            const pair = part.split('=');
            dict[pair[0]] = decodeURIComponent(pair[1]);
        });

        return dict;
    }
}